import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when user transcript is searched',
  name: 'searched_transcript',
  params: [
    {
      description: 'The ID of clip',
      name: 'clip_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Search term',
      name: 'search_term',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
